import React, { useState, useEffect } from 'react';
import RegionIcon from '../../assests/images/RegionSelectionIcon.svg';

const RegionSelection = ({ regions, handleRegionFilterChange, setSelectedRegionFilter }) => {
  const [selectedRegion, setSelectedRegion] = useState('Region');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (regions && regions.length > 0) {
      setSelectedRegion(regions[0]); // Default to the first region
    }
  }, [regions]);

  const handleRegionClick = (region) => {
    setSelectedRegion(region);
    setSelectedRegionFilter(region);
    setIsDropdownOpen(false);

    if (handleRegionFilterChange) {
      handleRegionFilterChange(region); // Ensure this is called
    }
  };

  return (
    <div style={{ position: 'relative', width: '170px', overflow: 'visible' }}>
      <div
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px',
          width: '170px',
          height: '32px',
          background: '#FBFCFE',
          cursor: 'pointer',
          borderRadius: '2px',
          marginTop: '4px'
        }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img src={RegionIcon} alt="Region Icon" style={{ height: '16px', width: '16px' }} />
          <span>{selectedRegion}</span>
        </div>
        <span
          style={{
            fontSize: '8px',
            transform: isDropdownOpen ? 'rotate(180deg)' : 'none'
          }}>
          ▼
        </span>
      </div>
      {isDropdownOpen && (
        <div
          role='listbox'
          style={{
            position: 'absolute',
            top: '36px',
            left: '0',
            background: '#FBFCFE',
            borderRadius: '4px',
            zIndex: 9999,
            width: '170px',
            maxHeight: '200px', // Restricts dropdown height
            overflowY: 'auto', // Enables vertical scrolling
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' // Allow scrolling within the dropdown if there are many regions
          }}>
          {regions.map((region, index) => (
            <div
              key={`${index +1}`}
              onClick={() => handleRegionClick(region)}
              role='option'
              style={{
                padding: '8px',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                whiteSpace: 'nowrap' // Ensure text doesn't wrap
              }}>
              {region}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RegionSelection;
